<template>
  <div>
    <Header></Header>
    <div class="partner-body">
      <div class="title">
        <img src="../../../static/img/web_img/title_par.png" />
      </div>
      <div class="list wrapper-box">
        <div v-for="(item,index) in list" :key="index" class="item">
          <div class="img-box">
            <img class="img" :src="'../../../static/img/web_img/pro_'+ index + '.png'" />
            <img class="logo" :src="'../../../static/img/web_img/logo_'+ index + '.png'" />
          </div>
          <h2>{{item.name}}</h2>
          <p>{{item.content}}</p>
          <div class="btn"></div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {
        list: [{
          name: '雅诗兰黛',
          url: '', //官网地址
          content: "雅诗兰黛是美国雅诗兰黛公司旗下的化妆品旗舰品牌，成立于1946年纽约，以抗衰修护护肤品闻名。雅诗兰黛公司是全球领先的大型生产商和销售商。雅诗兰黛旗下的护肤，彩妆以及香氛产品都成为了科学与艺术完美结合的最佳范例。1946年，雅诗兰黛夫人凭借着想“为每个女性带来美丽”的渴望创立了雅诗兰黛品牌。"
        }, {
          name: '兰蔻',
          url: '',
          content: "LANCOME属于世界第一大化妆品集团L'OREAL，1935年由阿曼达·珀蒂（Armand Petitjean）创立于巴黎，其名称来自法国中部一座城堡卢瓦卡河畔的兰可思幕城堡（LANCOSME）。城堡周围种满玫瑰花，Petitjean钟爱玫瑰，认为女人如同花朵的美丽各有其姿态与特色，因此以城堡为品牌名称，城堡里的玫瑰花就成了品牌标帜。她的创始人阿曼达·珀蒂让先生凭借着对香水的天才敏感嗅觉、执著不懈的冒险精神，以及他立志让法国品牌在当时已被美国品牌垄断的全球化妆品市场占领一席要位。"
        }, {
          name: '梅西百货',
          url: '',
          content: "梅西百货（Macy’s）创立于1858年，是美国一个历史悠久的连锁百货公司。梅西百货从1924年开始，每年感恩节都会在纽约市举行盛大的感恩节大游行。而且每年圣诞节都会有别出风格的主题橱窗秀。2018财年的销售额为249.71亿美元，员工人数约为130,000人。"
        }, {
          name: 'Nordstrom',
          url: '',
          content: '诺德斯特龙百货公司是一家美国高档时装零售公司，由约翰·W·诺德斯特龙与卡尔·F·沃林创建于华盛顿州西雅图。公司最初是一家鞋类零售公司，后期将业务扩展至服饰、饰品、手袋、珠宝、化妆品和香水。'
        }, {
          name: '契尔氏',
          url: '',
          content: "Kiehl's （科颜氏/契尔氏） 1851年创立于纽约曼哈顿，早期Kiehl's （科颜氏） 以典型的19世纪药剂师的身份，提供纽约客药水及自然成分提炼的药膏。Kiehl's （科颜氏） 老店坐落在纽约第13街及第3大道的交叉口，以贩卖草药、精油、处方药、茶及蜂蜜为主。Kiehl's （科颜氏） 揉和了美容、药草、药学及医学等专业领域的知识背景，逐渐建立了其独特的形象，进而发展成全方位的药局，并推出第一个以Kiehl's （科颜氏） 命名的保养品。"
        }, {
          name: 'MAC',
          url: '',
          content: '1985年于加拿大多伦多由Frank Toskan及Frank Angelo创立。Toskan是专业化妆师及摄影师，而Angelo则是商人。二人认为在时装摄影中没有适合而可靠的化妆品，因此合作创办MAC。Frank Angelo在1997年1月12日逝世。MAC现由化妆品牌Estée Lauder拥有，总部位于美国纽约市。'
        }]
      }
    }
  }
</script>

<style lang="scss" scoped src="../../../static/css/enter/main.scss"></style>
<style lang="scss" scoped src="../../../static/css/enter/media.scss"></style>



// WEBPACK FOOTER //
// src/pages/web/partner.vue